import { queryClient } from '@vlabs/api';
import { useGetUser } from '@vlabs/api/artemy/client';
import { ForbidCircleIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';

import st from './UserBlockConfirmation.module.sass';
import { useConfirmUserBlockTranslation } from '../i18n';
import type { ConfirmUserBlockProps } from '../types';

type UserBlockConfirmationProps = ConfirmUserBlockProps & WithDataTestid;

function UserBlockConfirmation({
  userId,
  onConfirm,
  onReject,
  'data-testid': dataTestId = undefined,
}: UserBlockConfirmationProps): JSX.Element {
  const { t } = useConfirmUserBlockTranslation();
  const { data: user } = useGetUser(userId, undefined, queryClient);
  const userName = user?.full_name ?? user?.email;

  return (
    <div
      className={st.UserBlockConfirmation}
      data-testid={dataTestId}
    >
      <div className={st.Header}>
        <ForbidCircleIcon className={st.Icon} />
        <div className={st.Description}>
          <span className={st.Title}>{t('title')}</span>
          <span className={st.Subtitle}>
            {t('subtitle', { name: userName })}
          </span>
        </div>
      </div>

      <div className={st.Actions}>
        <Control.Button
          className={st.Action}
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('reject_button')}
        </Control.Button>
        <Control.Button
          className={st.Action}
          kind="negative"
          onClick={onConfirm}
          variant="filled"
        >
          {t('confirm_button')}
        </Control.Button>
      </div>
    </div>
  );
}

export { UserBlockConfirmation };
